/// <reference lib="es2022.intl" />

const japaneseOrHanScript =
  /[\p{Script_Extensions=Hiragana}\p{Script_Extensions=Katakana}\p{Script_Extensions=Han}]/u;
const letterOrMark = /[\p{L}\p{M}]/u;
const graphemes = new Intl.Segmenter('ja', { granularity: 'grapheme' });

export const MIN_LITERAL_RESULT_SEARCH_LENGTH = 2;
export const RESULT_SEARCH_MIN_LENGTH_MESSAGE =
  'Enter at least 2 non-space characters to search Japanese or Han text.';

/**
 * Kana and Han queries use literal matching because the default PostgreSQL
 * parser does not split unspaced Japanese words. Han also covers Chinese text;
 * the characters alone cannot reliably distinguish the two languages.
 */
export function usesLiteralResultSearch(query: string): boolean {
  return Array.from(query).some(
    (character) => letterOrMark.test(character) && japaneseOrHanScript.test(character),
  );
}

/** Count visible graphemes, so supplementary kanji and combining kana count once. */
export function getResultSearchValidationError(query: string): string | null {
  if (!usesLiteralResultSearch(query)) {
    return null;
  }

  let count = 0;
  for (const { segment } of graphemes.segment(query)) {
    if (/[^\p{White_Space}\p{Default_Ignorable_Code_Point}\p{Cc}]/u.test(segment)) {
      count++;
      if (count >= MIN_LITERAL_RESULT_SEARCH_LENGTH) {
        return null;
      }
    }
  }
  return RESULT_SEARCH_MIN_LENGTH_MESSAGE;
}
